import { useSession, useSignOut } from '@church/data'
import { Link, Outlet, createFileRoute, redirect } from '@tanstack/react-router'
import { Button } from '../components/ui.tsx'
import { signInUrl, urlOn } from '../lib/site.ts'

/**
 * The platform console (admin.forhim.io, Phase 12f) — for the people who run
 * ForHim, not for any church. Platform operators only (`users.role = 'admin'`,
 * from PLATFORM_ADMIN_EMAILS); the server refuses everyone else, and this
 * redirect is manners.
 */
export const Route = createFileRoute('/_authed/admin')({
  beforeLoad: ({ context }) => {
    if (!context.me.platformOperator) throw redirect({ href: urlOn('id', '/apps') })
  },
  component: AdminLayout,
})

const nav = [
  { to: '/admin', label: 'Churches', exact: true },
  { to: '/admin/plans', label: 'Plans', exact: false },
  { to: '/admin/ai', label: 'AI', exact: false },
  { to: '/admin/catalog', label: 'Catalog', exact: false },
  { to: '/admin/log', label: 'Log', exact: false },
  { to: '/admin/spotify', label: 'Spotify', exact: false },
] as const

function AdminLayout() {
  const { me } = useSession()
  const signOut = useSignOut()
  return (
    <div className="min-h-screen bg-surface-base">
      <header className="border-b border-border-subtle bg-surface-raised">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-x-6 gap-y-2 px-6 py-3">
          <span className="font-semibold text-content-default">ForHim Admin</span>
          <nav className="flex gap-1">
            {nav.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                activeOptions={{ exact: item.exact }}
                className="rounded-lg px-3 py-1.5 text-sm text-content-muted hover:bg-surface-sunken hover:text-content-default"
                activeProps={{ className: 'bg-surface-sunken text-content-default' }}
              >
                {item.label}
              </Link>
            ))}
          </nav>
          <span className="ml-auto text-sm text-content-muted">{me?.user.email}</span>
          <Button
            variant="ghost"
            onClick={() =>
              signOut.mutate(undefined, {
                onSettled: () => window.location.assign(signInUrl(window.location.href)),
              })
            }
          >
            Sign out
          </Button>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-6 py-8">
        <Outlet />
      </main>
    </div>
  )
}
